import { CatalogueService } from './catalogue.service';
import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';
import * as CatalogueActions from './catalogue.action';
import * as CatalogueModels from '../../models/catalogue/catalogue';
import { CatalogueSearchModel } from '../../models/catalogue/catalogueSearch';
import { BannerService } from '../../shared/services/banner.service';
import { SaveState } from '../../models/commonModels';
import { HelperService } from '../../../../src/app/services/helper/helper.service';

export interface CatalogueStateModel {
  CatalogueSave: SaveState;
  CatalogueList: CatalogueModels.CatalogueListModel;
  Catalogue: CatalogueModels.CatalogueModel;
  CatalogueSearch: CatalogueSearchModel;
}

@State<CatalogueStateModel>({
    name: 'catalogueState',
    defaults: {
      CatalogueList: null,
      CatalogueSave: null,
      Catalogue: null,
      CatalogueSearch: null
    }
})

@Injectable()

export class CatalogueState {

    constructor(
                private helperService: HelperService,
                private catalogueService: CatalogueService,
                private bannerService: BannerService
                ) { }

  @Selector()
  static CatalogueList(state: CatalogueStateModel) {
    return state.CatalogueList;
  }

  @Selector()
  static CatalogueSave(state: CatalogueStateModel) {
    return state.CatalogueSave;
  }

  @Selector()
  static Catalogue(state: CatalogueStateModel) {
    return state.Catalogue;
  }

  @Selector()
  static CatalogueSearch(state: CatalogueStateModel) {
    return state.CatalogueSearch;
  }

  @Action(CatalogueActions.SetCatalogue)
  setCatalogue(
    context: StateContext<CatalogueStateModel>,
    action: CatalogueActions.SetCatalogue
  ) {
    const errorMessage = 'Błąd zapisu szczegółów katalogu.';

    this.catalogueService.set(action.Catalogue).subscribe(
      ret => {
        this.bannerService.success('Zmiany szczegółów katalogu zapisane.');

        context.setState(
          patch({
            CatalogueSave: new SaveState(action.Catalogue.TyreId, true)
          })
        );

        context.dispatch(new CatalogueActions.Refresh(action.Catalogue));
      },

      (error) => {

        context.setState(
          patch({
            CatalogueSave: new SaveState(action.Catalogue.TyreId, false)
          })
        );


        this.helperService.SaveException('CatalogueActions.SetCatalogue', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(CatalogueActions.GetCatalogueList)
  getCatalogueList(
    context: StateContext<CatalogueStateModel>,
    action: CatalogueActions.GetCatalogueList
  ) {

    const errorMessage = 'Błąd pobierania listy katalogów.';

    context.setState(
      patch({
        CatalogueList: null
      })
    );

    this.catalogueService.getList(action.Search).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            CatalogueList: ret
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('CatalogueActions.GetCatalogueList', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(CatalogueActions.GetCatalogue)
  getCatalogue(
    context: StateContext<CatalogueStateModel>,
    action: CatalogueActions.GetCatalogue
  ) {

    const errorMessage = 'Błąd pobierania szczegółów katalogu.';

    context.setState(
      patch({
        Catalogue: null
      })
    );

    this.catalogueService.get(action.CatalogueId).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            Catalogue: ret.Item
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('CatalogueActions.GetCatalogue', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(CatalogueActions.Refresh)
  Refresh(
    context: StateContext<CatalogueStateModel>,
    action: CatalogueActions.Refresh
  ) {

    const errorMessage = 'Błąd pobierania szczegółów katalogu.';

    this.catalogueService.get(action.Catalogue.TyreId).subscribe((ret) => {
      if (ret.Success) {

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('CatalogueActions.Refresh', error);

        this.bannerService.error(errorMessage);
      });
  }


  @Action(CatalogueActions.SetCatalogueSearch)
  setCatalogueSearch(
    context: StateContext<CatalogueStateModel>,
    action: CatalogueActions.SetCatalogueSearch
  ) {

    action.Search.CurrentPage = 1;

    context.setState(
      patch({
        CatalogueSearch: action.Search
      }));

    context.dispatch(new CatalogueActions.GetCatalogueList(action.Search));
  }

  @Action(CatalogueActions.SetCatalogueListPage)
  setDepositeListPage(
    context: StateContext<CatalogueStateModel>,
    action: CatalogueActions.SetCatalogueListPage
  ) {

    context.setState(
      patch({
        CatalogueSearch: action.Search
      }));

    context.dispatch(new CatalogueActions.GetCatalogueList(action.Search));
  }

  @Action(CatalogueActions.ResetCatalogueSearch)
  resetDepositeSearch(
    context: StateContext<CatalogueStateModel>
  ) {

    const state = context.getState();

    const catalogueSearch = new CatalogueSearchModel();

    catalogueSearch.ItemsPerPage = state.CatalogueSearch.ItemsPerPage;

    context.setState(
      patch({
        CatalogueSearch: catalogueSearch
      }));

    context.dispatch(new CatalogueActions.GetCatalogueList(state.CatalogueSearch));
  }

  @Action(CatalogueActions.DeleteCatalogueItem)
  deleteCatalogueItem(
    context: StateContext<CatalogueStateModel>,
    action: CatalogueActions.DeleteCatalogueItem
  ) {

    const errorMessage = 'Błąd podczas usuwania opony.';

    context.setState(
      patch({
        CatalogueSave: null
      })
    );

    this.catalogueService.delete(action.TyreId).subscribe((ret) => {
      if (ret === action.TyreId) {
        this.bannerService.success('Usunięto oponę z katalogu.');
        context.setState(
          patch({
            CatalogueSave: new SaveState(action.TyreId, true )
          })
        );

        return ret;

      } else {
        this.bannerService.error(errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('CatalogueActions.DeleteCatalogueItem', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(CatalogueActions.Insert)
  insert(
    context: StateContext<CatalogueStateModel>,
    action: CatalogueActions.Insert
  ) {
    const errorMessage = 'Błąd zapisu nowego opony do katalogu.';

    context.setState(
      patch({
        CatalogueSave: null
      })
    );


    this.catalogueService.insertNew(action.Tyre).subscribe(
      ret => {
        this.bannerService.success('Dodano oponę do katalogu.');

        context.setState(
          patch({
            CatalogueSave: new SaveState(null, true)
          })
        );
      },

      (error) => {
        context.setState(
          patch({
            CatalogueSave: new SaveState(null, false)
          })
        );


        this.helperService.SaveException('PricelistDetailActions.Insert', error);

        this.bannerService.error(`${errorMessage}`);
      },
      () => {});
  }

  @Action(CatalogueActions.Set)
  set(
    context: StateContext<CatalogueStateModel>,
    action: CatalogueActions.Insert
  ) {
    const errorMessage = 'Błąd zapisu zmian w katalogu.';

    context.setState(
      patch({
        CatalogueSave: null
      })
    );


    this.catalogueService.set(action.Tyre).subscribe(
      ret => {
        this.bannerService.success('Zapisano zmiany katalogu.');

        context.setState(
          patch({
            CatalogueSave: new SaveState(null, true)
          })
        );
      },

      (error) => {
        context.setState(
          patch({
            CatalogueSave: new SaveState(null, false)
          })
        );


        this.helperService.SaveException('CatalogueActions.Set', error);

        this.bannerService.error(`${errorMessage}`);
      },
      () => {});
  }


  @Action(CatalogueActions.DisposeSearch)
  disposeSearch(
      context: StateContext<CatalogueStateModel>
    ) {

      context.setState(
        patch({
          CatalogueSearch: null
        }));
  }
}
